import type { OnboardingPopup } from '@mathflat/domain/Notice'

import OnboardingPopupModal from '@/contentComponents/modal/OnboardingPopupModal'
import type { FetchPopupProps } from '@/controller/notice.controller'
import { noticeController } from '@/controller/notice.controller'
import type { Academy, User } from '@/dto'
import commonRepo from '@/repository/common.repo'

import modalService from './modal.service'
import { localStorageService } from './storage.service'

export type OnboardingNameT = 'PRACTICE_TEST_BATCH_SELECT' | 'SIGNATURE_WORKBOOK'

class _PopupService {
  onboardingPopup: OnboardingPopup[] = []

  private isOpenableOnboarding(targetName: OnboardingNameT) {
    if (!commonRepo.user) {
      return false
    }

    const STOARGE_KEY = `ONBOARDING_POPUP_READ_${commonRepo.user.teacherId}` as const
    const storedNames = localStorageService.getItem(STOARGE_KEY)
    const targetPopup = this.onboardingPopup.find(({ name }) => name === targetName)

    if (!targetPopup || storedNames?.find((name) => name === targetPopup.name)) {
      return false
    }

    return true
  }

  checkAndOpenOnboardingPopup(targetName: OnboardingNameT) {
    if (commonRepo.user && this.isOpenableOnboarding(targetName)) {
      const STOARGE_KEY = `ONBOARDING_POPUP_READ_${commonRepo.user.teacherId}` as const
      const storedNames = localStorageService.getItem(STOARGE_KEY)

      if (storedNames) {
        localStorageService.setItem(STOARGE_KEY)([targetName, ...storedNames])
      } else {
        localStorageService.setItem(STOARGE_KEY)([targetName])
      }

      const targetPopup = this.onboardingPopup.find(({ name }) => name === targetName)!
      modalService.openModal(<OnboardingPopupModal {...targetPopup} />, { hasCloseButton: false })
    }
  }

  async fetchAndSetOnboardingPopups(teacherId: User['teacherId']) {
    const onboardingPopups = await noticeController.fetchOnboardingPopup(teacherId)
    this.onboardingPopup.push(...onboardingPopups)
  }
  async getFirstCommonPopup(
    teacherId: User['teacherId'],
    academyStatus: Academy['status'],
    academyMetaData: Academy['metadata'],
    academyAuthority: Academy['authority'],
    brandStatus: FetchPopupProps['brandStatus'],
  ) {
    const _popups = await noticeController.fetchNoticeBoard({
      teacherId,
      academyAuthority: academyAuthority === 'SOLO' ? 'BASIC' : academyAuthority,
      academyMetaData,
      academyStatus,
      brandStatus,
    })

    return _popups.filter(
      ({ targetDCode }) =>
        !targetDCode ||
        (commonRepo.academy?.academyId &&
          new RegExp(`\\b${commonRepo.academy.academyId}\\b`).test(targetDCode)),
    )
  }
}

const popupService = new _PopupService()
export default popupService
